import request from "@/service";

/* 查询奖惩列表 */
export function pageList(data) {
  return request({
    url: `/user/study/credit/page`,
    method: "get",
    params: data
  });
}

/* 部门人员查询 */
export function getDeptUser(params) {
  return request({
    url: `/user/sys/dept/treeUser`,
    method: "get",
    params
  });
}

/* 新增奖励 */
export function rewardSave(data) {
  return request({
    url: `/user/study/credit/reward`,
    method: "post",
    data
  });
}

/* 新增惩罚 */
export function punishmentSave(data) {
  return request({
    url: `/user/study/credit/punishment`,
    method: "post",
    data
  });
}

/* 批量删除奖惩记录 */
export function recordsDelete(data) {
  return request({
    url: `/user/study/credit/delete`,
    method: "delete",
    data
  });
}

// 
export function checkRewardUsers(data) {
  return request({
    url: `/resource/user/creditDetail/creditCheck`,
    method: "post",
    data
  });
}




